// Money is handled as integer cents everywhere except text the user types or reads.
// parseMoneyToCents mirrors server/helpers/money.js so both sides agree on rounding.

// Parse "$1,200.50" (or a number of dollars) into integer cents.
// Empty input is 0; anything that is not an amount returns null.
export function parseMoneyToCents (value) {
  if (value === null || value === undefined) return 0
  let str
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return null
    str = String(value)
    if (/e/i.test(str)) return Math.round(value * 100)
  } else if (typeof value === 'string') {
    if (value.trim() === '') return 0
    str = value.replace(/[\s$,]/g, '')
  } else {
    return null
  }

  const match = /^(-?)(\d*)(?:\.(\d*))?$/.exec(str)
  if (!match || (match[2] === '' && (match[3] === undefined || match[3] === ''))) return null

  const negative = match[1] === '-'
  const whole = match[2] === '' ? 0 : parseInt(match[2], 10)
  const fraction = match[3] || ''
  let cents = whole * 100 + parseInt((fraction + '00').slice(0, 2), 10)
  if (fraction.length > 2 && fraction[2] >= '5') cents += 1
  return negative ? -cents : cents
}

// 120050 -> "$1,200.50"
export function formatCents (cents) {
  return ((cents || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

// 120050 -> "1200.50", for filling a text input. 0 -> '' so the field shows its placeholder.
export function centsToInput (cents) {
  return cents ? (cents / 100).toFixed(2) : ''
}
